import { render } from "./ProfileSidebar.vue?vue&type=template&id=74f997ce&scoped=true"
import script from "./ProfileSidebar.vue?vue&type=script&lang=js"
export * from "./ProfileSidebar.vue?vue&type=script&lang=js"

import "./ProfileSidebar.vue?vue&type=style&index=0&id=74f997ce&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74f997ce"]])

export default __exports__